export default __webpack_public_path__ + "static/media/auteuil16.ca199d69.jpg";